import { PackageProviderName } from './constants';

export const HOME_DELIVERY_AVAILABLE_PROVIDERS = [
    PackageProviderName.MPL_PACKAGE_POINT,
    PackageProviderName.FOXPOST,
    PackageProviderName.GLS,
    PackageProviderName.DPD,
    PackageProviderName.TOURMIX,
    PackageProviderName.FAN_COURIER,
    PackageProviderName.FAN_COURIER_INTERNATIONAL,
    PackageProviderName.SAMEDAY,
    PackageProviderName.INPOST,
    PackageProviderName.PPL,
    PackageProviderName.BAL_KOVNA,
    // Kvikk's own carriers (grouped and shown as one "Kvikk" entry on the orders page, but each is
    // its own PackageProviderName — see constants.ts).
    PackageProviderName.KVIKK_GLS,
    PackageProviderName.KVIKK_DPD,
    PackageProviderName.KVIKK_PACKETA,
    PackageProviderName.KVIKK_MPL,
    PackageProviderName.KVIKK_FOXPOST,
    PackageProviderName.CARGUS,
    PackageProviderName.ONE_BY_ALLEGRO_WEDO,
    PackageProviderName.GLS_POLAND,
    PackageProviderName.ECONT,
    PackageProviderName.DPD_POLAND,
];
